"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M150 220.4l86.5 87c7.4 7.5 19.5 7.5 26.9 0l86.6-87c11.9-12 3.4-32.4-13.5-32.4H163.4c-16.9 0-25.3 20.4-13.4 32.4z"
  });
};

exports.default = _default;